import { useState, useEffect, useCallback } from "react";
import { permissionsService } from "./permissionsService";

export function usePermissions({ autoLoad = true } = {}) {
  const [role, setRole] = useState(null);
  const [features, setFeatures] = useState([]);
  const [loading, setLoading] = useState(autoLoad);

  const refresh = useCallback(async () => {
    setLoading(true);
    try { const d = await permissionsService.me(); setRole(d.role); setFeatures(d.features || []); return d; }
    catch (e) { setRole(null); setFeatures([]); return null; }
    finally { setLoading(false); }
  }, []);

  useEffect(() => { if (autoLoad) refresh(); }, [autoLoad, refresh]);

  const can = useCallback((feature) => features.includes(feature), [features]);

  return { role, features, loading, can, refresh };
}
